import { IEmailCollectionItem } from '@sales-center/common'
import { getIn, setIn, useFormikContext } from 'formik'
import { useCallback } from 'react'

export const useEmailCollection = <T>(name: string) => {
  const { values, setValues } = useFormikContext<T>()
  const emailsAddresses: IEmailCollectionItem[] = getIn(values, name)

  const addEmail = useCallback(() => {
    const emailAdresses = [
      ...emailsAddresses,
      { emailAddress: '', isPrimary: emailsAddresses?.length === 0 },
    ]

    setValues((current) => {
      let next = { ...current }

      next = setIn(next, `${name}`, emailAdresses)
      return next
    })
  }, [name, setValues, emailsAddresses])

  const count = emailsAddresses?.length ?? 0

  return { addEmail, count }
}
